<template>
  <div>
    <div class="hero-container">
      <div v-if="!videoLoaded" class="preloader">
        <!-- Latausindikaattori täällä -->
      </div>
      <div v-else-if="loadingProgress < 100" class="video-loading">
        <p>Ladataan...</p>
      </div>
      <video
        ref="video"
        autoplay
        loop
        preload="metadata"
        class="hero-video"
        @loadedmetadata="initializeVideo"
        @loadeddata="videoLoaded = true"
        @canplaythrough="videoCanPlayThrough"
        playsinline
      >
        <source :src="videoFile" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div class="hero-overlay"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      videoFile: "", // Videon polku
      videoLoaded: false, // Lisää tieto video-latauksen tilasta
      loadingProgress: 0 // Latauksen edistyminen prosentteina
    };
  },
  methods: {
    initializeVideo() {
      const videoPlayer = this.$refs.video;
      videoPlayer.volume = 0; // Aseta äänenvoimakkuus nollaan
      // Älä aloita videon toistoa tässä
    },
    playVideo() {
      const videoPlayer = this.$refs.video;
      videoPlayer.play();
    },
    videoCanPlayThrough() {
      // Tässä vaiheessa video on ladattu ja voi toistua turvallisesti
      this.playVideo();
    },
    updateLoadingProgress() {
      const videoPlayer = this.$refs.video;
      if (videoPlayer) {
        const loaded = videoPlayer.buffered.end(0); // Ladattu osuus videosta
        const duration = videoPlayer.duration; // Videon kesto
        this.loadingProgress = (loaded / duration) * 100;
      }
    }
  },
  mounted() {
    this.videoFile = require("@/assets/videos/video-all-mobile.mp4");

    // Päivitä latauspalkkia 500 millisekunnin välein
    setInterval(this.updateLoadingProgress, 500);
  }
};
</script>

<style scoped>
.hero-container {
  position: relative;
  min-height: 100%;
  padding: 0.5rem 0;
  background: black;
}

.hero-video {
  width: 100%;
  max-height: 100vh;
  object-fit: cover;
}

.preloader,
.video-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* Taustan läpinäkyvyys */
  color: #fff;
  z-index: 999; /* Aseta korkein z-indeksi varmistaaksesi, että se on päällimmäisenä */
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #fff;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
}

.progress-bar {
  width: 50%;
  height: 10px;
  border-radius: 30px;
  background-color: rgba(255, 255, 255, 0.3);
}

.progress-bar div {
  height: 100%;
  background-color: #fff;
  transition: width 0.2s;
  border-radius: 30px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom right, #c37da6, #cf71a8);
  opacity: 0.2;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/Videowall-mobile.vue